/* Stylesheet */

.label {
  font-size: 1rem;
  color: var(--ion-color-text-tertiary);
}
